import { useState } from 'react';

import { useNavigate } from 'react-router-dom';


const VhndTabs = () => { 
  const [activeTab, setActiveTab] = useState('Overview');
 const navigate = useNavigate();

      const handleTabClick = (tab) => {
          setActiveTab(tab); // Add this line to update tab style
        if(tab == 'Overview'){
          navigate('/vhnd-overview');
        }
          if(tab == 'Upcoming'){
          navigate('/vhnd-upcoming');
        }
           if(tab == 'Past Events'){
          navigate('/vhnd-event-summary');
        }
              if(tab == 'Reports'){
          navigate('/task-summary');
        } 
  }; 

  return (
   <div className="tabs flex border-b mb-4">
        {['Overview', 'Upcoming', 'Past Events', 'Reports'].map((tab, index) => (
          <div
            key={index}
            onClick={() => handleTabClick(tab)}
            className={`tab px-4 py-2 cursor-pointer transition-colors duration-300 ${
              activeTab === tab
                ? 'text-blue-600 border-b-2 border-blue-600 font-semibold'
                : 'text-gray-600'
            }`}
          >
            {tab}
          </div>
        ))}
      </div>
  );
};

export default VhndTabs;  